<template>
  <RevInputSelect
    v-if="props.shouldShow"
    id="category"
    :label="i18n(translations.label)"
    :model-value
    :options="[{ label: i18n(translations.all), value: '' }, ...options]"
    @update:model-value="(value) => emit('update:modelValue', value)"
  />
</template>

<script setup lang="ts">
import { catalogAccessAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { type Option, RevInputSelect } from '@ds/components/InputSelect'

import translations from './SelectCategory.translations'
import { transformPayloadToOptions } from './SelectCategory.utils'

const props = withDefaults(
  defineProps<{
    modelValue: string
    shouldShow?: boolean
  }>(),
  {
    shouldShow: true,
  },
)
const emit = defineEmits(['update:modelValue'])

const i18n = useI18n()

const { data: options } = await useHttpFetch(
  catalogAccessAPI.getCategoriesLeafLight,
  {
    queryParams: { my_categories: true },
    transform: (data) => transformPayloadToOptions(data),
    default: () => [] as Option[],
  },
)
</script>
